export function eur(cents: number): string {
  const sign = cents < 0 ? '−' : ''
  const abs = Math.abs(cents)
  return `${sign}${Math.floor(abs / 100)},${String(abs % 100).padStart(2, '0')} €`
}

/** Igual que `eur` pero anteponiendo siempre el signo, para el desglose. */
export function eurSigned(cents: number): string {
  return cents >= 0 ? `+${eur(cents)}` : eur(cents)
}

const DAYS = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo']
const DAYS_SHORT = ['L', 'M', 'X', 'J', 'V', 'S', 'D']
const MONTHS = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
]

function parts(isoDate: string) {
  const [y, m, d] = isoDate.split('-').map(Number)
  const date = new Date(Date.UTC(y, m - 1, d))
  const jsDay = date.getUTCDay()
  return { y, m, d, isoWeekday: jsDay === 0 ? 7 : jsDay }
}

/** 'martes 18' */
export function dayLabel(isoDate: string): string {
  const { d, isoWeekday } = parts(isoDate)
  return `${DAYS[isoWeekday - 1]} ${d}`
}

/** '14 ago' */
export function shortDate(isoDate: string): string {
  const { d, m } = parts(isoDate)
  return `${d} ${MONTHS[m - 1].slice(0, 3)}`
}

/** '14 – 20 de agosto' */
export function weekLabel(start: string, end: string): string {
  const a = parts(start)
  const b = parts(end)
  return a.m === b.m
    ? `${a.d} – ${b.d} de ${MONTHS[a.m - 1]}`
    : `${a.d} ${MONTHS[a.m - 1].slice(0, 3)} – ${b.d} ${MONTHS[b.m - 1].slice(0, 3)}`
}

export function weekdayInitials(days: number[]): string {
  if (days.length === 0) return 'todos los días'
  return days
    .slice()
    .sort((x, y) => x - y)
    .map((d) => DAYS_SHORT[d - 1])
    .join(' ')
}

export const DAY_NAMES = DAYS
export const DAY_INITIALS = DAYS_SHORT
